import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import authApi from '@/api/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    authUser: null,
    languages: {
      en: 1,
      kh: 2
    }
  },
  getters: {
    authenticated: state => state.authUser !== null,
    accessToken: state =>
      state.authUser !== null ? state.authUser.access_token : null,
    permissionAllowCode: state =>
      state.authUser !== null ? state.authUser.permission_allow_code : null,
    permissions: state =>
      state.authUser !== null ? state.authUser.permissions : null,
    limitStringShow: state => text => {
      if (text != null) {
        let article = text.replace(/(<([^>]+)>)/gi, '')
        return article.length > 60 ? article.substring(0, 60) + '...' : article
      }
      return ''
    }
  },
  mutations: {
    setAuthUser(state, authUser) {
      if (authUser) {
        state.authUser = Object.assign(
          {},
          {
            user: authUser.user,
            user_type: authUser.user_type,
            login_as: authUser.login_as,
            refresh_token: authUser.refresh_token,
            expires_in: authUser.expires_in,
            access_token: authUser.access_token,
            permission_allow_code: authUser.permission_allow_code,
            permissions: authUser.permissions
          }
        )

        localStorage.setItem('authUser', JSON.stringify(state.authUser))
      } else {
        state.authUser = null
        localStorage.clear()
      }
    }
  },
  actions: {
    init({ commit }) {
      const authUser = JSON.parse(localStorage.getItem('authUser'))
      if (authUser) {
        commit('setAuthUser', authUser)
      }
    },
    login({ commit }, formData) {
      return authApi.login(formData).then(response => {
        commit('setAuthUser', response.data)
        return Promise.resolve(response)
      })
    },
    logout({ commit }) {
      commit('setAuthUser', null)
    }
  },
  modules
})

store.dispatch('init')

export default store
